import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterById', // O nome usado para chamar este pipe no template
})
export class FilterByIdPipe implements PipeTransform {
  transform(items: any[], filterId: number | undefined): any[] {
    if (!items) return [];
    if (!filterId) return items; // Checa se filterId é fornecido e não é zero

    return items.filter((item) => item.expenseType === filterId); // Retorna itens filtrados
  }
}
